import { useMemo } from 'react';

import catalystLogoImg from '@assets/images/catalyst-logo.png';
import myomeLogoImg from '@assets/images/full_logo.svg';
import { ReactComponent as NateraLogoSvg } from '@assets/images/natera/natera-web-logo.svg';
import { IS_NATERA } from '@constants/constants';
import { CATALYST_CAMPAIGN_CODE } from '@constants/clinician';
import { Campaign } from '@customTypes/campaign';

interface IProps {
  campaign?: Campaign;
}

const NewReportCardImage = ({ campaign }: IProps) => {
  const isCatalyst = useMemo(() => campaign?.campaign_code === CATALYST_CAMPAIGN_CODE, [campaign?.campaign_code]);

  if (IS_NATERA) {
    return <NateraLogoSvg className='natera-logo' />;
  }
  if (isCatalyst) {
    return <img src={catalystLogoImg} alt='Catalyst Logo' height={50} />;
  }
  if (campaign) {
    return <span className='lh-xs fw-bold fs-4 campaign-name'>{campaign.name}</span>;
  }
  return <img src={myomeLogoImg} alt='MyOme logo' height={50} />;
};

export default NewReportCardImage;
